module.exports = __webpack_public_path__ + "img/logo-ticketshop-footer.b101873d.png";